import { Button, Card, Col, Modal, Row, Tooltip } from "antd"
import SpinnerLarge from "./SpinnerLarge"
import { useState } from "react";
import ModalEditarTitular from "./ModalEditarTitular";
import { TitularVehiculo } from "../../titulares-vehiculo/useTitularesVehiculoAPI";
import Velocidad from "./IconosInfraccion/exceso-de-velocidad.png"
import Adelantamiento from "./IconosInfraccion/adelantamiento.png"
import Semaforo from "./IconosInfraccion/luz-roja.png"
import Estacionar from "./IconosInfraccion/no-estacionar.png"
import LucesBajas from "./IconosInfraccion/luces-bajas.png"
import SinDatos from "./IconosInfraccion/sin-dato.png"
import { size } from "lodash";
import { json } from "react-router-dom";

export default (props: any) => {
    const [isModalImagenOpen, setIsModalImagenOpen] = useState(false);
    const [isVideoModalVideoOpen, setIsVideoModalVideoOpen] = useState(false);
    const [isModalTitularOpen, setIsModalTitularOpen] = useState(false);

    const modalTitleStyle = {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    };

    const boldTextStyle = {
        fontWeight: 600
    };

    const formatTelefonosCelulares = (titular: { telefonosCelulares: string; telefonosFijo:string; emails:string}, tipoDato: number) => {
    
        let telefonosCelularesArray = [];
        let telefonosFijoArray = [];
        let emailsArray = [];

        try {
            if(tipoDato == 1){
                telefonosCelularesArray = JSON.parse(titular?.telefonosCelulares ?? '[]');

                return telefonosCelularesArray
                .filter((tel: { CelularArea: any; CelularTelefono: any; }) => tel.CelularArea && tel.CelularTelefono) // Filtra los vacíos
                .map((tel: { CelularArea: any; CelularTelefono: any; TieneWhatsapp?: boolean; }, index: number) => (
                    <a 
                        href={`https://wa.me/54${tel.CelularArea}${tel.CelularTelefono}`} 
                        key={index} 
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {`${tel.CelularArea}${tel.CelularTelefono} ${tel.TieneWhatsapp ? '(WhatsApp)' : ''} - `}
                    </a>
                ));
            }

            if(tipoDato == 2){
                telefonosFijoArray = JSON.parse(titular?.telefonosFijo ?? '[]');

                return telefonosFijoArray
                .filter((tel: { Area: any; Telefono: any; }) => tel.Area && tel.Telefono) // Filtra los vacíos
                .map((tel: { Area: any; Telefono: any; }) => `${tel.Area}${tel.Telefono}`) // Formatea
                .join(", ") ?? 'Sin datos';
            }

            if(tipoDato == 3){
                emailsArray = JSON.parse(titular?.emails ?? '[]');
                return emailsArray
                .filter((mail: { Email: any; }) => mail.Email) // Filtra los vacíos
                .map((mail: { Email: any; }) => `${mail.Email}`) // Formatea
                .join(", ") ?? 'Sin datos';
            }
            
           
            
        } catch (error) {
            console.error("Error al parsear", error);
            return "Formato inválido";
        }
    };

    const handleDownload = async (imageUrl: string, imageName: string) => {
        try {
            const response = await fetch(imageUrl);
            const blob = await response.blob();

            const urlParts = imageUrl.split('/');
            const fileName = urlParts[urlParts.length - 1];
            const fileExtension = fileName.split('.').pop() || 'jpg'; //
    
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = imageName ? `${imageName}.${fileExtension}` : `infraccion.${fileExtension}`;
            document.body.appendChild(link);
            link.click(); 
            document.body.removeChild(link); 
            URL.revokeObjectURL(link.href); 
        } catch (error) {
            console.error('Error al descargar la imagen:', error);
        }
    };

    const getColorFromFecha = (fecha:string):string => {
        const fechaParametro = new Date(fecha); 
        const hoy = new Date();
        hoy.setHours(0, 0, 0, 0);
        fechaParametro.setHours(0, 0, 0, 0);
        return fechaParametro < hoy ? "#ff4d4f" : "#52c41a"; 
    }

    const closeModalTitular = () => {
        setIsModalTitularOpen(false);
    }

    const getLinkPago = (data: string) =>{
        var pagoData = JSON.parse(data);
        return pagoData.url_qr;
    } 

    const getIcon = (descripcionCodigo:string | '') => {
    const semaforoArray = ['rojo', 'roja', 'rojos', 'rojas', 'verde'];
    const lucesBajasArray = ['bajas', 'baja', 'falta de luces', 'ausencia de luces'];
    const adelantamientoArray = ['adelantarse', 'contramano'];
    const estacionarArray = ['frenar', 'estacionar', 'detenerse'];
    const velocidadArray = ['velocidad'];

    try {
        if(semaforoArray.some((palabra) => descripcionCodigo.toLocaleLowerCase().includes(palabra))) return Semaforo;
        else if (lucesBajasArray.some(palabra => descripcionCodigo.toLocaleLowerCase().includes(palabra))) return LucesBajas;
        else if (adelantamientoArray.some(palabra => descripcionCodigo.toLocaleLowerCase().includes(palabra))) return Adelantamiento;
        else if (estacionarArray.some(palabra => descripcionCodigo.toLocaleLowerCase().includes(palabra))) return Estacionar;
        else if (velocidadArray.some(palabra => descripcionCodigo.toLocaleLowerCase().includes(palabra))) return Velocidad;
        else return SinDatos;
    } catch (error) {
        return SinDatos;
    }
    }
    
    return (
        <>
    <Modal 
             title={
                <div style={modalTitleStyle}>
                <span>
                    <span style={boldTextStyle}>Unidad de Producción:</span>
                    <span> {props.selectedRecord?.unidadProduccionNombre}</span>
                    {' - '}
                    <span style={boldTextStyle}>Lugar:</span>
                    <span> {props.selectedRecord?.lugar}</span>
                </span>
                <Tooltip title={props.selectedRecord?.descripcionCodigo || 'Sin dato'}>
                    <img 
                    src={getIcon(props.selectedRecord?.descripcionCodigo)} 
                    alt="icono" 
                    style={{
                        width: '2em',
                        height: '2em',
                        marginLeft: '8px',
                        flexShrink: 0 // Evita que la imagen se reduzca
                    }} 
                    />
                </Tooltip>
                </div>
            }
            open={props.isModalDescargarVisible} 
            onCancel={props.handleModalClose}
            footer={null}
            width={'75%'}
        >
            <SpinnerLarge spinning={props.spinVisible} tip="Procesando..."/>
            {props.selectedRecord && (
                    <div>
                        {/* Tarjeta para los datos de la persona */}
                        <Card 
                            title="Datos del infractor y del vehículo"
                            style={{ marginBottom: 16 }}
                            headStyle={{ backgroundColor: '#2145D9', color: '#fff' }}
                        >
                              <Row gutter={16}>
                                <Col span={12}>
                                    <p><strong>DNI/CUIT:</strong> {props.selectedRecord.titular.cuilTitular}</p>
                                    <p><strong>Nombre completo:</strong> {props.selectedRecord.titular.nombreCompletoTitular}</p>
                                    <p><strong>Dirección:</strong> {props.selectedRecord.titular.direccionCompletaTitular}</p>
                                    <p><strong>Teléfono celular:</strong> {formatTelefonosCelulares(props.selectedRecord.titular, 1)}</p>
                                    <p><strong>Teléfono fijo:</strong> {formatTelefonosCelulares(props.selectedRecord.titular, 2)}</p>
                                    <p><strong>Email:</strong> {formatTelefonosCelulares(props.selectedRecord.titular, 3)}</p>
                                </Col>
                                <Col span={12}>
                                    <p><strong>Patente:</strong> {props.selectedRecord.patente}</p>
                                    <p><strong>Marca:</strong> {props.selectedRecord.titular.marcaVehiculo}</p>
                                    <p><strong>Modelo:</strong> {props.selectedRecord.titular.modeloVehiculo}</p>
                                    <p><strong>Localidad:</strong> {props.selectedRecord.titular.localidadTitularOriginal}</p>
                                    <p><strong>Provincia:</strong> {props.selectedRecord.titular.provinciaTitularOriginal}</p>
                                </Col>
                            </Row>
                        </Card>

                        {/* Tarjeta para los datos de la infracción */}
                        <Card 
                            title="Datos de la Infracción" 
                            style={{ marginBottom: 16 }}
                            headStyle={{ backgroundColor: '#2145D9', color: '#fff' }}
                        >
                            <Row gutter={16}>
                                <Col span={12}>
                                    <p><strong>Nro Acta:</strong> {props.selectedRecord.nroTramite}</p>
                                    <p><strong>Fecha infracción:</strong> {props.formatDate(props.selectedRecord.fechaInfraccion)}</p>
                                    <p><strong>Fecha emisión:</strong> {props.formatDate(props.selectedRecord.fechaEmision)}</p>
                                    <p style={{color: getColorFromFecha(props.selectedRecord.vencimientoPagoVountario)}}>
                                        <strong>Vencimiento pago voluntario:</strong> {props.formatDate(props.selectedRecord.vencimientoPagoVountario)}
                                        <strong>&nbsp;-&nbsp;Importe: $ {(props.selectedRecord.valorUF * props.selectedRecord.cotizacionUF * props.selectedRecord.porcentajeDescuentoPagoVoluntario / 100) + props.selectedRecord.gastosAdministrativos}</strong>
                                    </p>
                                    <p style={{color: getColorFromFecha(props.selectedRecord.fecha2doVencimiento)}}>
                                        <strong>Vencimiento pago total:</strong> {props.formatDate(props.selectedRecord.fecha2doVencimiento)}
                                        <strong>&nbsp;-&nbsp;Importe: $ {(props.selectedRecord.valorUF * props.selectedRecord.cotizacionUF) + props.selectedRecord.gastosAdministrativos}</strong>
                                    </p>
                                    <p><strong>Regenerada:</strong> {props.selectedRecord.regenerada}</p>
                                    <p><strong>Estado acta:</strong>
                                        <span style={{ color: props.selectedRecord.estado === "IMPRESION_GENERADA" ? "#52c41a" : "#ff4d4f" }}>
                                            &nbsp;{props.selectedRecord.estado}
                                        </span>
                                    </p>
                                    <p><strong>Acta enviada por email:</strong> {props.selectedRecord.actaEnviadaEmail ? 'Sí' : 'No'}</p>
                                    <p><strong>Fecha acta enviada por email:</strong> {props.formatDate(props.selectedRecord.fechaActaEnviadaEmail)}</p>
                                </Col>
                                <Col>
                                    <p><strong>Lugar infracción:</strong> {props.selectedRecord.lugar}</p>
                                    <p>
                                        <strong>Estado correo postal:</strong> {props.selectedRecord.Correo?.Estado ? props.selectedRecord.Correo?.Estado + ' - ' + props.selectedRecord.Correo?.NombreCorreo + '. Ult. Actualización: ' + props.formatDate(props.selectedRecord.Correo?.FechaEstado) : ''}
                                    </p>
                                    <p><strong>Artículo infracción:</strong> {props.selectedRecord.articuloCodigo}</p>
                                    <p><strong>Descripción:</strong> {props.selectedRecord.descripcionCodigo}</p>
                                    <p><strong>Referencia de pago:</strong> {props.selectedRecord.referenciaPago}</p>
                                    <p><strong>Link de pago:</strong>
                                        <Tooltip title='Click para copiar'>
                                        <span
                                            onClick={()=>navigator.clipboard.writeText(getLinkPago(props.selectedRecord.linkPago))}
                                            style={{cursor: "pointer", color: "blue", textDecoration: 'underline'}}>
                                                &nbsp;{getLinkPago(props.selectedRecord.linkPago)}
                                        </span>
                                        </Tooltip>
                                    </p>
                                    <p><strong>Estado pago:</strong>
                                        <span style={{ color: props.selectedRecord.estadoPago === "PAGADA" ? "#52c41a" : "#ff4d4f" }}>
                                            &nbsp;{props.selectedRecord.estadoPago}
                                        </span>
                                    </p>
                                    <p><strong>Acta enviada por correo postal:</strong> {props.selectedRecord.actaEnviadaPostal ? 'Sí' : 'No'}</p>
                                    <p><strong>Fecha acta enviada por postal:</strong> {props.formatDate(props.selectedRecord.fechaActaEnviadaPostal)}</p>
                                </Col>
                            </Row>
                          
                            <div style={{ marginTop: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div style={{ display: 'flex', gap: 8 }}>
                                    <Button 
                                        type="primary" 
                                        onClick={props.handleDescargarUltimaImpresa}
                                    >
                                        Descargar última impresa
                                    </Button>
                                    <Button 
                                        type="default" 
                                        onClick={props.handleRegenerar}
                                    >
                                        Regenerar
                                    </Button>
                                </div>
                                <div style={{ display: 'flex', gap: 8 }}>
                                <Button 
                                        type="default"
                                        onClick={() => setIsModalTitularOpen(true)}
                                    >
                                        Editar titular
                                    </Button>
                                    <Button 
                                        type="default"
                                        onClick={() => setIsModalImagenOpen(true)}
                                    >
                                        Ver foto
                                    </Button>
                                    <Button 
                                        type="default" 
                                        onClick={() => setIsVideoModalVideoOpen(true)}
                                    >
                                        Ver video
                                    </Button>
                                </div>
                            </div>
                        </Card>
                        {/* Tarjeta para datos del Descargo */}
                        <Card 
                            title="Datos descargo" 
                            style={{ marginBottom: 16 }}
                            headStyle={{ backgroundColor: '#2145D9', color: '#fff' }}
                        >
                            <Row gutter={16}  style={{ 
                                backgroundColor: 
                                props.selectedRecord?.estadoJuzgamiento === 'DESCARGO_PRESENTADO' || 
                                props.selectedRecord?.estadoJuzgamiento === 'SENTENCIA_REALIZADA' 
                                    ? 'rgba(255, 200, 200, 0.48)'  // Rojo suave con transparencia
                                    : 'transparent'                  // Color por defecto
                            }}>
                                <Col span={12}>
                                    <p><strong>Motivo:</strong> {props.selectedRecord.descargo?.descripcionMotivo}</p>
                                    <p><strong>Fecha de presentación:</strong> {props.formatDate(props.selectedRecord.descargo?.fechaPresentacion) ?? ''}</p>
                                    <p><strong>Fecha de resolución:</strong> {props.formatDate(props.selectedRecord.descargo?.fechaResolucion) ?? ''}</p>
                                    <p><strong>Nro Res/Sen/Trá:</strong> {props.selectedRecord.descargo?.documentoResolucion?.nroResolucion}</p>
                                </Col>
                                <Col>
                                    <p><strong>Estado juzgamiento:</strong> {props.selectedRecord.estadoJuzgamiento}</p>
                                    {/* <p>
                                        <strong>Estado correo postal:</strong> {props.selectedRecord.Correo?.Estado ? props.selectedRecord.Correo?.Estado + ' - ' + props.selectedRecord.Correo?.NombreCorreo + '. Ult. Actualización: ' + props.formatDate(props.selectedRecord.Correo?.FechaEstado) : ''}
                                    </p>
                                    <p><strong>Artículo infracción:</strong> {props.selectedRecord.ArticuloCodigo}</p>
                                    <p><strong>Descripción:</strong> {props.selectedRecord.DescripcionCodigo}</p>
                                    <p><strong>Referencia de pago:</strong> {props.selectedRecord.ReferenciaPago}</p>
                                    <p><strong>Estado pago:</strong>
                                        <span style={{ color: props.selectedRecord.EstadoPago === "PAGADA" ? "#52c41a" : "#ff4d4f" }}>
                                            &nbsp;{props.selectedRecord.EstadoPago}
                                        </span>
                                    </p> */}
                                </Col>
                            </Row>
                            <div style={{ marginTop: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                {props.selectedRecord.descargo?.documentoResolucion?.fullUrl.length > 0 &&(
                                    <div style={{ display: 'flex', gap: 8 }}>
                                    <Button 
                                        type="primary" 
                                        onClick={props.handleDescargaResolucionJuzgado}
                                    >
                                        Descargar resolucion
                                    </Button>
                                </div>
                                )}
                            </div>
                        </Card>
                    </div>
                )}
    </Modal>

    {/* Imagenes de la infraccion */}
     <Modal
        title="Imagen de la infracción"
        open={isModalImagenOpen}
        footer={null}
        onCancel={() => setIsModalImagenOpen(false)}
        width={'50%'}
        >
             <Button
                    type="primary"
                    onClick={() => handleDownload(props.selectedRecord?.imagenes[0]?.FullUrl,  `${props.selectedRecord.nroTramite}-imagen 1`)}
                >
                    Descargar Imagen 1
                </Button>
                <Button
                    type="primary"
                    onClick={() => handleDownload(props.selectedRecord?.imagenes[1]?.FullUrl, `${props.selectedRecord.nroTramite}-imagen 2`)}
                    style={{ marginLeft: '8px' }}
                >
                    Descargar Imagen 2
                </Button>
            <img
                src={props.selectedRecord?.imagenes[0]?.fullUrl}
                alt="Infracción"
                style={{ width: "100%", borderRadius: "8px", padding: "0.5em" }}
            />
            <img
                src={props.selectedRecord?.imagenes[1]?.fullUrl}
                alt="Infracción"
                style={{ width: "100%", borderRadius: "8px", padding: "0.5em" }}
            />
    </Modal>

    {/* Video de la infraccion */}
    <Modal
        title="Video de la infracción"
        open={isVideoModalVideoOpen}
        footer={null}
        onCancel={() => setIsVideoModalVideoOpen(false)}
    >
        <video width="100%" controls>
            <source src={props.selectedRecord?.videos[0]?.fullUrl} type="video/mp4" />
            Tu navegador no soporta videos.
        </video>
    </Modal>

    <ModalEditarTitular 
        open={isModalTitularOpen}
        onCancel={setIsModalTitularOpen}
        titular={props.selectedRecord?.titular}
    />
 </>
)}